export function getTitle(file: File) {
    let rawTitle = file.name;
    let rawName = rawTitle.includes('.') ? rawTitle.split('.').shift() : rawTitle;
    return rawName!.replace(/[^a-zA-Z0-9-]/g, ' ');
}